const NUMERIC_EMPLOYEE_ID = /^\d+$/;

const isNumericEmployeeId = (
  employeeId: string | null | undefined,
): employeeId is string => {
  if (!employeeId) {
    return false;
  }
  return NUMERIC_EMPLOYEE_ID.test(employeeId.trim());
};

export { isNumericEmployeeId };
